export const SET_PROMO_IS_USED = 'SET_PROMO_IS_USED';

export const setPromoIsUsed = (payload) => {
  return {
    type: SET_PROMO_IS_USED,
    payload,
  };
};
